module.exports = __webpack_public_path__ + "img/Fred.25423514.jpg";